function NavIcon({ children, className = '' }) {
  return (
    <svg
      aria-hidden="true"
      className={`h-6 w-6 ${className}`.trim()}
      fill="none"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      >
        {children}
      </g>
    </svg>
  )
}

export function HomeNavIcon(props) {
  return (
    <NavIcon {...props}>
      <path d="m3 10 9-7 9 7M5 9v11h5v-7h4v7h5V9" />
    </NavIcon>
  )
}

export function CollectionNavIcon(props) {
  return (
    <NavIcon {...props}>
      <path d="M10 4.75h4M10.75 4.75v2.5h2.5v-2.5" />
      <rect x="7.25" y="7.25" width="9.5" height="12" rx="2" />
      <path d="M7.25 11.25h9.5M10 15.25h4" />
    </NavIcon>
  )
}

export function LogNavIcon(props) {
  return (
    <NavIcon {...props}>
      <path d="M7 5h10M7 10h10M7 15h6" />
      <path d="M5 3h14v18H5z" />
    </NavIcon>
  )
}

export function WearLogNavIcon(props) {
  return (
    <NavIcon {...props}>
      <path d="M13.5 5H6.75A1.75 1.75 0 0 0 5 6.75v10.5C5 18.22 5.78 19 6.75 19h10.5c.97 0 1.75-.78 1.75-1.75V10.5" />
      <path d="m11 13 1.25-3.5 5.9-5.9a1.27 1.27 0 0 1 1.8 1.8l-5.9 5.9L11 13Z" />
    </NavIcon>
  )
}

export function AddNavIcon(props) {
  return (
    <NavIcon {...props}>
      <rect x="5" y="5" width="14" height="14" rx="3" />
      <path d="M12 8.5v7M8.5 12h7" />
    </NavIcon>
  )
}

export function ExploreNavIcon(props) {
  return <NavIcon {...props}><circle cx="10.5" cy="10.5" r="5.5" /><path d="m15 15 4.5 4.5" /></NavIcon>
}

export function InsightsNavIcon(props) {
  return <NavIcon {...props}><path d="M5 19.5h14M7 16V11M12 16V5M17 16V8" /></NavIcon>
}

export function LayeringNavIcon(props) {
  return <NavIcon {...props}><path d="m3 8 9-5 9 5-9 5-9-5Zm0 5 9 5 9-5M3 18l9 5 9-5" transform="translate(0 -1)" /></NavIcon>
}

export function ProfileNavIcon(props) {
  return <NavIcon {...props}><circle cx="12" cy="7" r="4" /><path d="M4 21v-2a8 8 0 0 1 16 0v2" /></NavIcon>
}

export const BOTTOM_NAV_ICONS = [
  { label: 'Home', Icon: HomeNavIcon },
  { label: 'Collection', Icon: CollectionNavIcon },
  { label: 'Today', Icon: LogNavIcon },
  { label: 'Layering', Icon: LayeringNavIcon },
  { label: 'Profile', Icon: ProfileNavIcon },
]
